var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestimanialsHeadShapWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 25,
    viewBox: "0 0 65 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.998 0L53.1339 12.1072L41.775 23.7515L64.7623 22.9873L63.998 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.09375L12.6443 12.4527L24.7515 23.3168L1.76421 24.0811L1 1.09375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0251 24.0214L33.1484 23.6499L40.2823 23.5753L32.3501 0.052134L26.0251 24.0214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimanialsHeadShapWhite);
export default __webpack_public_path__ + "static/media/testimanials_head_shap_white.933c9c4418283d5a3e3a3bd699240aa3.svg";
export { ForwardRef as ReactComponent };